module.exports = {
      id: "libra-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#libra",
      toString: function () {
        return this.url;
      }
    }